import { type Sale } from "@/services/marketplace/order/sales/salesTypes";

export const hasSomePackages = (sale: Sale): boolean => sale.shipping.parcels.length > 0;
